/* eslint-disable */
import axios from "axios";
import { urlBase } from "../constants/defaultValues"
import { encode } from 'base-64';

const baseUrl = urlBase

const login = (body) => {
    var contrasenaCifrada = body.password
    for(let i=0; i<5; i++){
        contrasenaCifrada = encode(contrasenaCifrada)
    }
    body.password = contrasenaCifrada
    return axios.post(`${baseUrl}/auth/login`, body)
}
 
export const obtnerModulosMenus = (id, headers) => axios.get(`${baseUrl}/auth/modulos_menus/${id}`, {headers})

export default login